import { QueryClient } from "@tanstack/react-query";

// Memory only: never persist taxpayer-derived query results in browser storage.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      staleTime: 0,
      gcTime: 0,
      refetchOnWindowFocus: false,
    },
    mutations: { retry: false },
  },
});

let authenticatedScope = "";
export function bindQuerySession(userId?: string, workspaceId?: string) {
  const next =
    userId && workspaceId ? JSON.stringify([userId, workspaceId]) : "";
  const changed = authenticatedScope !== next;
  if (changed || !next) {
    // Cache removal alone does not erase an active observer's displayed result.
    // The caller must also unmount the old workspace before loading a new scope.
    queryClient.clear();
    authenticatedScope = next;
  }
  return changed;
}
